import * as React from "react";
import * as Modal from "react-modal";
import { ITranslationProps, translateComponent } from "../../helpers/translation";

interface IConfirmModalProps extends ITranslationProps {
    isOpen: boolean;
    onRequestClose: () => void;
    onConfirmation: () => void;
    title: string;
    message: string;
}

function ConfirmModal(p: IConfirmModalProps) {

    function okClick() {
        p.onRequestClose();
        p.onConfirmation();
    }

    return (
        <Modal isOpen={p.isOpen}
            onRequestClose={p.onRequestClose}
            style={{
                content: {
                    position: "relative",
                    top: "auto",
                    bottom: "auto",
                    left: "auto",
                    right: "auto",
                    maxWidth: "500px",
                    margin: "1.75rem auto",
                    padding: "10px"
                },
                overlay: {
                    zIndex: 10
                }
            }}>
            <div className="modal-header">
                <h5 className="modal-title">{p.title}</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={p.onRequestClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                {p.message}
            </div>
            <div className="modal-footer">
                <button data-id="confirm-button-cancel" type="button" className="btn btn-secondary" data-dismiss="modal" onClick={p.onRequestClose}>{p.t("Global.Cancel")}</button>
                <button data-id="confirm-button-ok" type="button" className="btn btn-primary px-4" onClick={okClick}>{p.t("Global.OK")}</button>
            </div>
        </Modal>
    );
}

export default translateComponent(ConfirmModal);



// WEBPACK FOOTER //
// ./src/core/ConfirmModal/ConfirmModal.tsx